import React from 'react';
import { useLocale } from '../../context/LocaleContext';
import { MessageCircle, Search, Truck, ShoppingBag } from 'lucide-react';

const ROADMAP_ICONS = [Search, MessageCircle, Truck, ShoppingBag];

// index.tsx'ten ayrıştırıldı — landing "Roadmap" bölümü
export default function Roadmap({ L }: any) {
  const { locale, brandName } = useLocale();
  const ROADMAP = L.roadmap.items.map((item: any, i: number) => ({ ...item, icon: ROADMAP_ICONS[i] }));
  return (
    <>
        <section className="py-14 md:py-20 relative">
          <div className="divider-glow mb-16 mx-12" />
          <div className="max-w-4xl mx-auto px-6 text-center">
            <div className="reveal inline-block glass-panel px-4 py-2 rounded-full text-xs text-[#F59300] uppercase tracking-widest font-semibold mb-6">
              {L.roadmap.badge}
            </div>
            <h2
              className="reveal reveal-delay-1 text-3xl md:text-4xl font-black text-white mb-8"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              {L.roadmap.titlePrefix} <span className="gradient-text">{locale === "tr" ? "Geliyor" : "Coming"}</span>
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {ROADMAP.map((item, i) => {
                const RoadIcon = item.icon;
                return (
                <div
                  key={i}
                  className={`reveal reveal-delay-${i + 1} glass-panel gradient-border rounded-2xl p-6 text-left ${item.live ? '' : 'opacity-75 hover:opacity-100'} transition-opacity tilt-card`}
                >
                  <RoadIcon size={28} className={`${item.live ? 'text-[#34C3A0]' : 'text-[#F59300]'} mb-4`} />
                  <h3 className="text-white font-bold mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
                    {item.title}
                  </h3>
                  <p className="text-gray-500 text-sm leading-relaxed">{item.desc}</p>
                  <span className={`inline-block mt-3 text-xs font-semibold px-3 py-1 rounded-full ${item.live ? 'text-[#34C3A0] bg-[rgba(52, 195, 160,0.12)]' : 'text-[#F59300] bg-[rgba(245, 147, 0,0.12)]'}`}>
                    {item.live ? L.roadmap.live : L.roadmap.soon}
                  </span>
                </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* ── YORUMLAR / SOSYAL KANIT SECTION ─────────────────── */}
    </>
  );
}
